var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',_vm._b({attrs:{"dense":"","outlined":""},on:{"change":function($event){return _vm.$emit('change', $event)}}},'v-checkbox',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }